export default __webpack_public_path__ + "static/media/tu_condicion@2x.0f59d3cd.png";